package com.gsb.vyapar.bhagya.presentation.category.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.isBusinessDeleted
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.util.launchBusinessDetail
import com.gsb.vyapar.bhagya.presentation.business.view.BusinessCard
import com.gsb.vyapar.bhagya.presentation.category.uistate.getCategoriesViewUiState
import com.gsb.vyapar.bhagya.presentation.common.image.CategoryPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.menu.OutlinedExpandedSelectMenu
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.presentation.common.toolbar.ToolbarSearch
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.theme.unfocussed
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
fun CategoryView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        var selectedCategory by remember { mutableStateOf(uiState.categoriesViewUiState.category) }
        val listState = rememberLazyListState()
        val businessListState = rememberLazyListState()
        val coroutineScope = rememberCoroutineScope()
        Column {
            ToolbarSearch(selectedCategory.name)
            Row(modifier = Modifier.fillMaxWidth().padding(start = 8.dp, top = 8.dp)) {
                LazyColumn(
                    modifier = Modifier.width(if (uiState.isPortrait) 130.dp else 170.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    state = listState
                ) {
                    if (uiState.isPortrait) {
                        items(uiState.getCategories().getCategoriesList(), key = { it.id }) { category ->
                            Card(
                                modifier = Modifier.width(120.dp).height(120.dp),
                                shape = RoundedCornerShape(8.dp),
                                backgroundColor = if (selectedCategory.id == category.id) unfocussed else offwhite,
                            ) {
                                Column(
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                    verticalArrangement = Arrangement.Center,
                                    modifier = Modifier.clickable {
                                        getCategoriesViewUiState().updateBusinessDetail(null)
                                        selectedCategory = category
                                        getBusinessUiState().updateFilteredBusinessList(category)
                                        coroutineScope.launch {
                                            businessListState.scrollToItem(0)
                                        }
                                    }
                                ) {
                                    CategoryPlaceHolder(category.id.toInt())
                                    Text14RegularB(text = category.name, color = black)
                                }
                            }
                            Spacer(Modifier.height(8.dp))
                        }
                    } else {
                        items(uiState.getCategories().getCategoriesList(), key = { it.id }) { category ->
                            Card(
                                modifier = Modifier.width(170.dp).height(170.dp),
                                shape = RoundedCornerShape(8.dp),
                                backgroundColor = if (selectedCategory.id == category.id) unfocussed else offwhite,
                            ) {
                                Column(
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                    verticalArrangement = Arrangement.Center,
                                    modifier = Modifier.clickable {
                                        getCategoriesViewUiState().updateBusinessDetail(null)
                                        selectedCategory = category
                                        getBusinessUiState().updateFilteredBusinessList(category)
                                        coroutineScope.launch {
                                            businessListState.scrollToItem(0)
                                        }
                                    }
                                ) {
                                    CategoryPlaceHolder(category.id.toInt(), 100.dp, 100.dp)
                                    Text14RegularB(text = category.name, color = black)
                                }
                            }
                            Spacer(Modifier.height(8.dp))
                        }
                    }
                }
                Column(modifier = Modifier.fillMaxWidth().padding(8.dp)) {
                    OutlinedExpandedSelectMenu("Select the SubCategory", selectedCategory.getSubCategoriesList(uiState.getSubCategories()).map { it.name }) {
                        getBusinessUiState().updateFilteredBusinessList(selectedCategory, it)
                        coroutineScope.launch {
                            businessListState.scrollToItem(0)
                        }
                    }
                    Spacer(Modifier.height(8.dp))
                    if (uiState.businessUiState.filteredList.isEmpty()) {
                        Column(Modifier.fillMaxSize(), verticalArrangement = Arrangement.Center, horizontalAlignment = Alignment.CenterHorizontally) {
                            CommonImage(painterResource(splash), Modifier.width(150.dp).height(150.dp))
                            Spacer(Modifier.height(8.dp))
                            Text14RegularBB(text = "No Listings Available Yet", color = black)
                            Spacer(Modifier.height(8.dp))
                            Text14RegularB(text = "Businesses are actively registering, and listings will be live soon. Check back shortly to discover new and exciting businesses!", color = black)
                        }
                    } else {
                        LazyColumn(state = businessListState) {
                            items(uiState.businessUiState.filteredList, key = { it.getId() }) { businessOld ->
                                val business = getBusinessUiState().isBusinessFetched.value[businessOld.getId()] ?: businessOld
                                if (!business.isBusinessDeleted()) {
                                    BusinessCard(uiState, onTriggerEvent, business) {
                                        getCategoriesViewUiState().updateBusinessDetail(business)
                                        launchBusinessDetail(business)
                                    }
                                    Spacer(Modifier.height(8.dp))
                                }
                            }
                        }
                    }
                }
            }
        }
        LaunchedEffect(Unit) {
            coroutineScope.launch { listState.scrollToItem(index = uiState.getCategories().getCategoriesList().indexOf(uiState.getCategories().getCategoriesList().find { it.id == selectedCategory.id })) }
            uiState.categoriesViewUiState.businessDetail?.let { businessDetail ->
                coroutineScope.launch { businessListState.scrollToItem(index = uiState.businessUiState.filteredList.indexOf(uiState.businessUiState.filteredList.find { it.getId() == businessDetail.getId() })) }
            }
        }
    }
}